import { YesNo } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';

const {
  formField: {
    systemPropertyAddressIsSameAsBusiness,
    systemPropertyAddressState,
  },
} = loanFormModel;

export class PropertyAddressStateValidation implements ValidationSchema {
  public name: string = systemPropertyAddressState.name;
  public label: string = systemPropertyAddressState.label;
  public dependsOn: string[] = [systemPropertyAddressIsSameAsBusiness.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(isSameAsBusiness: YesNo, schema: Yup.StringSchema) {
    if (isSameAsBusiness === 'No') return schema.required();
    return schema;
  }
}
export default new Validation(new PropertyAddressStateValidation());
